<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vpxSs0/image/front.jpg?1725276967986" alt="This image is the cover for the book Rita Goes Home"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rita Goes Home
      </h1>
      <p class="bookDescription body article font2">
        <p>After escaping from the awful Mr and Mrs Nicompoop, Rita sets off on a long, long journey back to Africa where her parents lived, and where they had been captured. On the way, she has a few scary moments where she has to think quickly to stay out of danger. But she is helped on her way by several acts of kindness – from humans and from other birds and animals – and she makes some good friends. This teaches her a lot about the world and about herself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Greaves
      </h2>
      
      <p class="authorDescription body article">David Greaves is retired, married and lives in Southwest France. After a career as the Head of Legal Department for an International Company, he has turned his hand to writing books for children. He has various likes, including music, literature, cricket, France and jigsaws.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7fdcfe9b